"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var React = _interopRequireWildcard(require("react"));

function SvgLinkedinMin(props) {
  return React.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    preserveAspectRatio: "xMidYMid meet",
    stroke: props.stroke,
    fill: props.fill
  }, props), React.createElement("path", {
    d: "M6.262 22.716H2.328V8.29h3.934v14.426zM4.295 6.626A2.305 2.305 0 012 4.314 2.305 2.305 0 014.295 2 2.305 2.305 0 016.59 4.313a2.304 2.304 0 01-2.295 2.314zM22 22.717h-3.934v-7.35c0-4.416-5.246-4.082-5.246 0v7.35H8.885V8.29h3.935v2.315C14.65 7.213 22 6.963 22 13.852v8.864z"
  }));
}

var _default = SvgLinkedinMin;
exports.default = _default;